import createPersistedState from 'vuex-persistedstate'
import entities from './entities'
import auth from './auth/auth'
import user from './auth/user'
import Chart from 'chart.js'
import api from './api'
import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    api,
    user,
    auth,
    entities
  },
  state: {
    innerLoading: false,
    askToLeave: false,
    darkTheme: false
  },
  actions: {
    setInnerLoading ({ commit }, loading) {
      commit('SET_INNER_LOADING', loading)
    },
    setDarkTheme ({ commit }, darkTheme) {
      Chart.defaults.global.defaultFontColor = darkTheme ? '#eee' : '#666'
      Chart.defaults.scale.gridLines.color = darkTheme ? '#666' : 'rgba(0, 0, 0, 0.1)'
      commit('SET_DARK_THEME', darkTheme)
    },
    AskToLeave ({ commit }, askToLeave) {
      if (askToLeave) {
        window.onbeforeunload = function () {
          return 'Are you sure you want to close the window?'
        }
      } else {
        window.onbeforeunload = null
      }
      commit('ASK_TO_LEAVE', askToLeave)
    }
  },
  mutations: {
    SET_INNER_LOADING (state, loading) {
      state.innerLoading = loading
    },
    SET_DARK_THEME (state, darkTheme) {
      state.darkTheme = darkTheme
    },
    ASK_TO_LEAVE (state, askToLeave) {
      state.askToLeave = askToLeave
    }
  }
})

store.dispatch('AskToLeave', false)

export default store
